/** Longest payer name shown unabridged inside an NOA action button. */
export const NOA_PAYER_BUTTON_MAX_LENGTH = 24;

type PayerNamed = { payer_name?: string | null };

/** The NOA's payer name, trimmed; null when it is missing or blank. */
export function getPayerName(item: PayerNamed): string | null {
  const name = item.payer_name?.trim();
  return name ? name : null;
}

/**
 * The single payer name shared by every item, or null when the list is empty,
 * any item has no payer name, or the items span more than one payer.
 */
export function getCommonPayerName(items: PayerNamed[]): string | null {
  if (items.length === 0) {
    return null;
  }
  const names = items.map(getPayerName);
  const first = names[0];
  if (first === null) {
    return null;
  }
  return names.every(name => name === first) ? first : null;
}

/** Shorten a payer name to at most `max` characters, ending in an ellipsis. */
export function shortenPayerName(
  name: string,
  max: number = NOA_PAYER_BUTTON_MAX_LENGTH
): string {
  if (name.length <= max) {
    return name;
  }
  return `${name.slice(0, max - 1).trimEnd()}…`;
}
